import React, { useEffect, useRef } from 'react';
import { useThemeLanguage } from '../context/ThemeLanguageContext';
import { getTranslation } from '../translations';
import './Video.css';

const Video = () => {
  const videoRef = useRef(null);
  const { language } = useThemeLanguage();
  const t = (key) => getTranslation(language, 'landing', key);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      // Set video properties
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.controls = false;

      // Ensure video stays muted
      const ensureMuted = () => {
        if (!video.muted) {
          video.muted = true;
        }
      };

      // Listen for volume changes
      video.addEventListener('volumechange', ensureMuted);
      
      // Check periodically to ensure it stays muted
      const muteCheckInterval = setInterval(ensureMuted, 500);

      // Try to play the video
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Autoplay was prevented, try again after user interaction
          console.log('Autoplay prevented, video will play when user interacts');
        });
      }

      return () => {
        video.removeEventListener('volumechange', ensureMuted);
        clearInterval(muteCheckInterval);
      };
    }
  }, []);

  return (
    <section className="video-section">
      <div className="container">
        <div className="section-header">
            <h2 className="video-title">{t('videoTitle')}</h2>
        </div>
        <div className="video-wrapper">
          <video
            ref={videoRef}
            className="video-player"
            src="/פרסומת בסלון בית של מילים.m4v"
            muted
            loop
            autoPlay
            playsInline
            disablePictureInPicture
            controlsList="nodownload nofullscreen noremoteplayback"
          />
          <div className="video-overlay"></div>
        </div>
      </div>
    </section>
  );
};

export default Video;

